export enum Events {
  Shutdown,
  Notice
}
